/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    fromEmail: z.string(),
    toEmail: z.string(),
    subject: z.string(),
    replyTo: z.string().nullish(),
    resendMessageId: z.string().nullish(),
    resendError: z.string().nullish(),
    resendStatusCode: z.number().nullish(),
    resendErrorName: z.string().nullish(),
    userEmail: z.string(),
    userName: z.string().nullish(),
    category: z.string().nullish(),
    message: z.string().nullish(),
    success: z.boolean(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    fromEmail: z.string(),
    toEmail: z.string(),
    subject: z.string(),
    replyTo: z.string().nullish(),
    resendMessageId: z.string().nullish(),
    resendError: z.string().nullish(),
    resendStatusCode: z.number().nullish(),
    resendErrorName: z.string().nullish(),
    userEmail: z.string(),
    userName: z.string().nullish(),
    category: z.string().nullish(),
    message: z.string().nullish(),
    success: z.boolean(),
}
).strict();

/**
 * `ResendEmailLog` schema excluding foreign keys and relations.
 */
export const ResendEmailLogScalarSchema = baseSchema;


/**
 * `ResendEmailLog` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ResendEmailLogSchema = ResendEmailLogScalarSchema;


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ResendEmailLogPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ResendEmailLogPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    fromEmail: z.string(),
    toEmail: z.string(),
    subject: z.string(),
    replyTo: z.string().nullish(),
    resendMessageId: z.string().nullish(),
    resendError: z.string().nullish(),
    resendStatusCode: z.union([z.number().nullish(), z.record(z.string(), z.unknown())]),
    resendErrorName: z.string().nullish(),
    userEmail: z.string(),
    userName: z.string().nullish(),
    category: z.string().nullish(),
    message: z.string().nullish(),
    success: z.boolean()
}).partial().passthrough();


/**
 * `ResendEmailLog` schema for create operations excluding foreign keys and relations.
 */
export const ResendEmailLogCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `ResendEmailLog` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ResendEmailLogCreateSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `ResendEmailLog` schema for update operations excluding foreign keys and relations.
 */
export const ResendEmailLogUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `ResendEmailLog` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ResendEmailLogUpdateSchema = ResendEmailLogUpdateScalarSchema;

